/** App-provided context merged into every custom RUM action (tenant, surface, etc.). */
export type RumGlobalContext = Readonly<{
  tenant?: string | null;
  surface?: string | null;
  panel_context_id?: string | null;
}>;

let globalContext: RumGlobalContext = {};

export function setRumGlobalContext(partial: RumGlobalContext): void {
  globalContext = { ...globalContext, ...partial };
}

export function getRumGlobalContext(): RumGlobalContext {
  return globalContext;
}

export function mergeRumAttributes(
  attributes: Record<string, unknown>,
): Record<string, unknown> {
  const ctx = getRumGlobalContext();
  const merged: Record<string, unknown> = { ...attributes };
  if (ctx.tenant) merged.tenant = ctx.tenant;
  if (ctx.surface) merged.surface = ctx.surface;
  if (ctx.panel_context_id) merged.panel_context_id = ctx.panel_context_id;
  return merged;
}
